import { Grid, Button, List, ListItem, ListItemAvatar, ListItemText, Avatar, ListItemSecondaryAction, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FileIcon from '@material-ui/icons/FileCopy';
import LinkIcon from '@material-ui/icons/Link';
import { FieldArray, Field, Formik, Form } from 'formik';
import React from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import Uploader from 'v2/components/Shared/Uploader';

import type { IForm } from 'v2/components/Shared/Content';

import MaterialSchema from './validations';

import type { Materials as MaterialsClass } from '../../classes/Affiliates';
import type { IMaterial } from '../../classes/Product';
import type { FormikProps } from 'formik';

interface IFile {
  name: string;
  id: any;
}

const LINK = 'l',
  FILE = 'm';

const materialsType = [
  {
    label: 'Arquivo',
    value: FILE,
  },
  {
    label: 'Link',
    value: LINK,
  },
];

interface IProps extends IForm<MaterialsClass> {}

const Materials = (props: IProps) => {
  const list = props.values;
  const ShowIfMaterial = createShowIf<IMaterial>();

  return (
    <FieldArray name='materials'>
      {({ push, remove }) => {
        const submit = (item: IMaterial, { resetForm }: FormikProps<IMaterial>) => {
          push(item);
          resetForm();
        };
        const rm = (index: any) => remove(index);
        return (
          <>
            <Formik
              initialValues={{ type: LINK, description: '', link: '', file_id: null, file_name: '' }}
              validationSchema={MaterialSchema}
              onSubmit={submit}
            >
              {({ isValid, dirty, values, submitForm, setFieldValue }: FormikProps<IMaterial>) => {
                const onFileSuccess = (file: IFile) => {
                  setFieldValue('file_name', file.name);
                  setFieldValue('file_id', file.id);
                };
                return (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Field label='Tipo de material' id={'type'} name={'type'} options={materialsType} component={SelectFormField} />
                      </Grid>
                      <Grid item xs={12}>
                        <Field label='Descrição' name={'description'} id={'description'} component={TextFormField} />
                      </Grid>
                      <ShowIfMaterial value={values} compare={{ eq: { type: LINK } }}>
                        <Grid item xs={12}>
                          <Field label='Link' name={'link'} id={'link'} component={TextFormField} />
                        </Grid>
                      </ShowIfMaterial>
                      <ShowIfMaterial value={values} compare={{ eq: { type: FILE } }}>
                        <Grid item xs={12}>
                          <Uploader onSuccess={onFileSuccess} />
                        </Grid>
                      </ShowIfMaterial>
                      <Grid item xs={12}>
                        <Button onClick={submitForm} disabled={!isValid || !dirty} fullWidth>
                          Adicionar
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
            <List>
              {list.materials.map((material: IMaterial, index: number) => (
                <ListItem key={`material-${index}`}>
                  <ListItemAvatar>
                    <Avatar>
                      <ShowIfMaterial value={material} compare={{ eq: { type: LINK } }}>
                        <LinkIcon />
                      </ShowIfMaterial>
                      <ShowIfMaterial value={material} compare={{ eq: { type: FILE } }}>
                        <FileIcon />
                      </ShowIfMaterial>
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={material.type === LINK ? material.link : material.file_name} secondary={material.description} />
                  <ListItemSecondaryAction>
                    <IconButton edge='end' aria-label='delete' onClick={() => rm(index)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </>
        );
      }}
    </FieldArray>
  );
};

export default Materials;
